import {DropzoneComponent} from 'react-dropzone-component';
import 'react-dropzone-component/styles/filepicker.css';
import 'dropzone/dist/min/dropzone.min.css';
import React, {Component} from 'react';
import { Button, Header, Icon, Modal, Card, Grid, Form, Input, Segment, Message, Image,List,Item, Checkbox,Divider, Popup } from 'semantic-ui-react';
import * as AlarmPlaceholder from "../../assets/placeholderImage.png";
import {uploadPVRoomDetails, uploadPVRoomImages} from "../../data/property_visit_api";
import * as unavailable from "../../assets/photo_unavailable.jpg";
import Loader from "../universal/loader";
import { CollapsiblePanel, Toggle } from '../universal/collapsiblePanel';
import AddNewPVRoom from './add_new_pv_room';
import {isSessionExpiringSoon} from "../../utils/validate_session_expiry";

const uuidv1 = require('uuid/v1');

class PropertyVisitReportRooms extends Component {

  constructor(props) {
    super(props);
    this.state = {
      saved: false,
      uploading: false,
      roomName: undefined,
      roomDescription: undefined,
      roomFlag: false,
      attachments: [],
      showAdd: true,
      rooms: [],
      notSaved: false,
      currentImageCount: 1,
      totalImageCount:0,
      uploadErrors:[]
    };
  }
  
  componentDidMount() {
    if (this.props.reportData) {
      let roomList = []
      
      this.props.reportData.property_visit_rooms.map((room) => {
        let newRoom = {
          roomName: room.room_name,
            roomDescription: room.room_description,
            roomIssues:room.room_issues,
          roomFlag: room.room_flag,
          client_id: room.client_id,
          images: [...room.property_visit_images]
        }
        roomList.push(newRoom);

      })
      this.setState({ rooms: roomList })
    }
  
  }

  uploadRooms = async () => {
    if(isSessionExpiringSoon()){
      this.props.showPasswordWindow(true);
      return;
  }
    this.setState({ uploading: true,uploadState:"text", uploadErrors:[]});
    let reportUpdateRooms = JSON.parse(JSON.stringify(this.state.rooms));
    console.log(reportUpdateRooms)
    let images = [];
    let newErrors = []

    for (let i = 0; i < reportUpdateRooms.length; i++) {

      for (let j = 0; j < reportUpdateRooms[i].images.length; j++) {

        let roomImage = reportUpdateRooms[i].images[j];
        if (roomImage["image"] && roomImage["image"]["dataURL"]) {
          images.push(this.state.rooms[i].images[j])
          reportUpdateRooms[i].images[j]["image"]["dataURL"] = undefined
        }
      }
    }
    let formData = { report_id: this.props.reportId, rooms: reportUpdateRooms }
    let roomResponse = await uploadPVRoomDetails(formData)
    if(!roomResponse.success) {
      newErrors.push(`Room details upload error - ${roomResponse.statusMessage.response? roomResponse.statusMessage.response.data.error:roomResponse.statusMessage}`)
    }
          if (roomResponse.statusMessage) {
        const msg = roomResponse.statusMessage.toLowerCase();
        if (msg.includes("no data") || msg.includes("401") || msg.includes("unauthorized")) {
            this.props.showPasswordWindow(true);
        }
    }
    this.setState({totalImageCount:images.length,uploadState:"image"})
    for (let i = 0; i < images.length; i++){
      this.setState({currentImageCount: i+1})
    const imageFormData = new FormData();
  imageFormData.append("id", images[i].client_id);
  imageFormData.append("file", images[i].image);
  let response = await uploadPVRoomImages(imageFormData)  
  if (!response.success){
      newErrors.push(response.statusMessage)
   }
}
    if(newErrors.length > 0) {
      this.setState({ notSaved: true,saved:false,uploading:false,uploadErrors:[...newErrors] })
    } else {
      this.setState({ notSaved: false,saved:true,uploading:false })
      setTimeout(() => {
        this.setState({saved:false})
      }, 3000);
      this.props.reloadData()
    }
    
   
  };

  deleteRooms = (index) => {
    let newRooms = [...this.state.rooms]
    newRooms.splice(index,1)
    this.setState({rooms:newRooms,notSaved:true})
  }
  
  addRoom = (roomToAdd) => {
    let newRooms = [...this.state.rooms, roomToAdd]
    this.setState({rooms:newRooms,notSaved:true})
  }


  render() {

    return (
        <Segment >
            <div>
                <Header textAlign="left"> Rooms{this.state.saved && <span className="info-success">Saved!</span>}
                    {this.state.notSaved && <span className="info-negative">Not Saved</span>}
                    <Button primary compact content="Save" disabled={this.state.uploading} loading={this.state.uploading}
                        className="pull-right icon-button" onClick={(e) => {
                            this.uploadRooms();
                        }} />
                </Header>
                {this.state.uploadErrors.length >0 && <Message>
                  <Message.Header>{`Image Upload Error Count - ${this.state.uploadErrors.length} (Retry upload by clicking Save again)`}</Message.Header>
                  {this.state.uploadErrors.map((error, index)=>{return <Message.List key={index}>{`${index} - ${error.response? error.response.data.error:error}`}</Message.List>})}
                  </Message>}
                {!this.state.uploading && <React.Fragment>
            <CollapsiblePanel>{this.state.rooms.map((room, index) => {
                     function preloadImages(dropzone) {
                       (room.images || []).forEach(function (i) {
                          const name = i.client_id;
                          let file = {url: i['image_path'], name: name, size: 1000000, id: name};
                         let imageUrl = i['image_path'];
                          if (i.image) {
                              file = i.image;
                              imageUrl = i.image.dataURL;
                          }

                          file['serverId'] = name;
                          file['accepted'] = true;
                          file['status'] = 'success';
                          file['upload'] = {
                              progress: 100,
                              total: 100000,
                              bytesSent: 100000
                          };
                          dropzone.files.push(file);

                          dropzone.emit("addedfile", file);
                          dropzone.emit("thumbnail", file, imageUrl);
                          dropzone.emit("complete", file);
                      });
                     }
              
                    let dropZone = null;
                    const componentConfig = {postUrl: 'no-url'};
                    let djsConfig = {autoProcessQueue: false, addRemoveLinks: true, maxFiles: 2000,acceptedFiles:"image/*"};
                    const eventHandlers = {
                        init: (dropzone) => {
                            dropZone = dropzone;
                        dropZone.autoDiscover = false;
                        preloadImages(dropzone)
                        },
                      addedfile: (file) => {
                        let imageObj = {
                          client_id:file.upload.uuid,
                          id: file.upload.uuid,
                          image: file
                        }
                        let newRooms = [...this.state.rooms]
                        let newImages = [...newRooms[index].images, imageObj]
                        newRooms[index].images = newImages
                        this.setState({rooms:newRooms });
                  
                        },
                      removedfile: (file) => {
                        
                        let newRooms = [...this.state.rooms]
                        let newImages = [...newRooms[index].images]
                        newImages = newImages.filter((_file) => {
                            return _file.client_id != file.serverId
                        })
                        newRooms[index].images = newImages
                        this.setState({rooms:newRooms})
                        //   let attachments = this.state.attachments;
                        //   if (attachments.indexOf(file) !== -1) {
                        //       attachments.splice(attachments.indexOf(file), 1);
                        //   }
                        // this.setState({ rooms: newRooms });
                      },
                        maxfilesexceeded: (file) => {
                            dropZone.removeFile(file);
                            this.setState({maxNumberOfFilesExceeded: true});
                            setTimeout(() => {
                                this.setState({maxNumberOfFilesExceeded: false})
                            }, 10000)
                        }
                    };
                
              
              
              
              return <Toggle key={room.client_id} title={<div className="field " style={{ display: 'inline' }}><span className="report-field-name">{room.roomName}</span>
                      <div style={{display: 'inline'}} className="pull-right">
                      <Popup
                          trigger={<Icon name="trash"
                                        size='large'
                                        color='grey'
                          />}
                          content={<Button negative content="Confirm Delete Room?"
                                          onClick={(e) => {
                                              this.deleteRooms(index);
                                          }}/>}
                          on="click"
                          position="right center"
                          hideOnScroll
                      />
                        </div>
                      </div>}>
                        <Form >
                        <Form.Group >
                          <Form.Field width={5}>
                            <label>Room Name</label>
                            <Input
                              type="text"
                              placeholder="Hallway"
                                ref="roomName"
                                value = {room.roomName}
                              required
                                onChange={(e) => {
                                  let newRoomList = [...this.state.rooms]
                                  newRoomList[index].roomName = e.target.value
                                this.setState({ rooms:newRoomList })
                              }}
                            />
                          </Form.Field>
                          <Form.Field width={5}>
                            <label>Room Description</label>
                            <Input
                              type="text"
                              placeholder="General Room Description"
                              ref="roomDescription"
                                required
                                value={room.roomDescription}
                              onChange={(e) => {
                                let newRoomList = [...this.state.rooms]
                                newRoomList[index].roomDescription = e.target.value
                              this.setState({ rooms:newRoomList })
                            }}
                            />
                          </Form.Field>
                        <Form.Field width={5}>
                            <label>Room Issues</label>
                            <Input
                              type="text"
                              placeholder="Issues Requiring Attention"
                              ref="roomIssues"
                                required
                                value={room.roomIssues}
                              onChange={(e) => {
                                let newRoomList = [...this.state.rooms]
                                newRoomList[index].roomIssues = e.target.value
                              this.setState({ rooms:newRoomList })
                            }}
                            /></Form.Field>
                        </Form.Group>
                        <DropzoneComponent key={this.props.reportId} config={componentConfig}
                          eventHandlers={eventHandlers}
                                djsConfig={djsConfig} />
                      </Form>
                      </Toggle>
                    })}</CollapsiblePanel>
            {/* #FORM TO ADD A pv %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%% */}
          <AddNewPVRoom addRoom={this.addRoom}></AddNewPVRoom>
          </React.Fragment>}
          {this.state.uploading && <Loader contain={true} customText={this.state.uploadState === "image" ? `Uploading Image ${this.state.currentImageCount} of ${this.state.totalImageCount} ` : "Uploading Room Data..."}></Loader>}
        </div>
      </Segment>
        );
    }
}

export default PropertyVisitReportRooms;


// WEBPACK FOOTER //
// ./src/views/property_visits/property_visit_report_rooms_list.js